import React from "react";
import { ArrowUpRight } from "lucide-react";

/* Affiliate partners, shown as recommendations because that is what they are.
   The disclosure sits in the footer, where it stays visible whichever section
   the reader scrolled to. */

export const Recommendations = ({ affiliates }) => {
  const partners = affiliates?.partners || [];
  if (!affiliates?.enabled || !partners.length) return null;

  return (
    <section className="mt-20" data-testid="recommendations">
      <p className="eyebrow">{affiliates.title}</p>
      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {partners.map((partner) => (
          <a
            key={partner.id}
            href={partner.url}
            target="_blank"
            // sponsored marks a paid link for search engines; nofollow alone
            // understates what this is
            rel="sponsored noopener noreferrer"
            data-testid={`partner-${partner.id}`}
            className="surface flex items-center gap-4 rounded-xl p-4 transition-transform hover:-translate-y-0.5"
          >
            {partner.image_url ? (
              <img
                src={partner.image_url}
                alt=""
                loading="lazy"
                className="h-14 w-14 shrink-0 rounded-lg object-cover"
              />
            ) : null}
            <div className="min-w-0 flex-1">
              <p className="text-[15px] font-semibold leading-tight">{partner.name}</p>
              {partner.blurb ? (
                <p className="mt-1 text-[12.5px] leading-relaxed text-[color:var(--ink-soft)]">
                  {partner.blurb}
                </p>
              ) : null}
            </div>
            <ArrowUpRight className="h-4 w-4 shrink-0" style={{ color: "var(--gild)" }} />
          </a>
        ))}
      </div>
    </section>
  );
};

export default Recommendations;
